import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.inserts || initialState;

export const selectInserts = createSelector([selectSlice], state => state.data);
